import React from "react";

/* First-letter avatar circle for reviews — deterministic color per name */
const PALETTE = [
  { bg: "#0f5132", fg: "#ffffff" },
  { bg: "#b45309", fg: "#ffffff" },
  { bg: "#9f1239", fg: "#ffffff" },
  { bg: "#1e40af", fg: "#ffffff" },
  { bg: "#6d28d9", fg: "#ffffff" },
  { bg: "#c2410c", fg: "#ffffff" },
  { bg: "#0e7490", fg: "#ffffff" },
  { bg: "#374151", fg: "#ffffff" },
];

export default function Avatar({ name = "?", size = 36 }) {
  const letter = (name.trim().charAt(0) || "?").toUpperCase();
  const idx = (name.charCodeAt(0) + (name.length || 1)) % PALETTE.length;
  const { bg, fg } = PALETTE[idx];
  return (
    <div
      className="rounded-full grid place-items-center font-extrabold shrink-0"
      style={{ width: size, height: size, background: bg, color: fg, fontSize: size * 0.42 }}
      aria-hidden="true"
    >
      {letter}
    </div>
  );
}
